module.exports = __webpack_public_path__ + "static/media/DG.a520a602.png";